/** 客户端设备 */
const userAgent = navigator.userAgent;
/** 移动设备 */
const isMobile$1 = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
/** IOS 终端 */
const isIOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(userAgent);
/** Mac 系统 */
const isMac = /Macintosh; Intel Mac OS/i.test(userAgent);
/** Windows 系统 */
const isWindowsNt = /Windows NT/i.test(userAgent);
/** 南方电网客户端 */
const eLinkClient = /WXWorkLocal/i.test(userAgent);
/** 钉钉客户端 */
const isDingtalkClient = /DingTalk/.test(userAgent);
/** 企业微信客户端(包括移动端、PC工作台) */
const isWxworkClient = /wxwork/i.test(userAgent) && !eLinkClient;
/** 企业微信PC客户端 */
const wxworkIsOnPc = isWxworkClient && (isWindowsNt || isMac);
/** 飞书客户端 */
const isFeishuClient = !!(userAgent.includes('Lark') || userAgent.includes('Feishu'));
/** 飞书PC客户端 */
const feishuIsOnPc = isFeishuClient && (isWindowsNt || isMac);
/** 第三方客户端(企微、飞书、钉钉) */
const isThirdPartyClient = isDingtalkClient || isWxworkClient || isFeishuClient;

var Navigator = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isMobile: isMobile$1,
    isIOS: isIOS,
    isMac: isMac,
    isWindowsNt: isWindowsNt,
    eLinkClient: eLinkClient,
    isDingtalkClient: isDingtalkClient,
    isWxworkClient: isWxworkClient,
    wxworkIsOnPc: wxworkIsOnPc,
    isFeishuClient: isFeishuClient,
    feishuIsOnPc: feishuIsOnPc,
    isThirdPartyClient: isThirdPartyClient
});

/** 是否开发环境 */
const isDevMode = process.env.NODE_ENV === 'development';
/** 是否生产环境 */
const isProdMode = process.env.NODE_ENV === 'production';
/** 请求前缀 */
const baseUrl = isDevMode ? '/api' : '';
/** 氚云域名 */
const H3Origin = isDevMode ? 'https://infrastructure.h3yun.com' : location.origin;
/** 氚云外链域名 */
const H3ExternalOrigin = isDevMode ? 'https://externalinfrastructure.h3yun.com' : location.origin;
/** 主应用部署域名 */
const AppOrigin = isDevMode ? 'https://localhost:8100' : location.origin;
/** 报表部署域名 */
const ReportOrigin = isDevMode ? 'https://localhost:8700' : location.origin;
/** 仪表盘部署域名 */
const DashboardOrigin = isDevMode ? 'https://localhost:8600' : location.origin;
/** 统计分析部署域名 */
const AnalysisOrigin = isDevMode ? 'https://localhost:8601' : location.origin;
/** Excel画布打印部署域名 */
const ExcelPrintOrigin = isDevMode ? 'https://localhost:8602' : location.origin;
/** 导入部署域名 */
const ImportDataOrigin = isDevMode ? 'http://localhost:5500' : location.origin;
/** 导入部署域名 */
const AutomationOrigin = isDevMode ? 'http://localhost:5600' : location.origin;

var Env = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isDevMode: isDevMode,
    isProdMode: isProdMode,
    baseUrl: baseUrl,
    H3Origin: H3Origin,
    H3ExternalOrigin: H3ExternalOrigin,
    AppOrigin: AppOrigin,
    ReportOrigin: ReportOrigin,
    DashboardOrigin: DashboardOrigin,
    AnalysisOrigin: AnalysisOrigin,
    ExcelPrintOrigin: ExcelPrintOrigin,
    ImportDataOrigin: ImportDataOrigin,
    AutomationOrigin: AutomationOrigin
});

/**
 * 遍历对象自身键，执行回调
 * @param obj 对象
 * @param callback 回调函数，接收对象自身键为参数
 */
function forEachOwnKey(obj, callback) {
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            callback(key);
        }
    }
}
/**
 * 对象映射，类似于数组的map方法，只是遍历的是对象自身的键
 * @param obj 对象
 * @param callback 回调函数，接收对象自身键为参数，返回值作为映射结果
 */
function map(obj, callback) {
    const result = {};
    forEachOwnKey(obj, (key) => {
        result[key] = callback(key);
    });
    return result;
}
/**
 * 对象过滤，类似于数组的filter方法，只是遍历的是对象自身的键
 * @param obj 对象
 * @param predicate 校验方法，接收对象自身键为参数，返回值为布尔值表示是否保留该字段
 * @returns 过滤后的新对象
 */
function filter(obj, predicate) {
    const result = {};
    forEachOwnKey(obj, (key) => {
        if (predicate(key)) {
            result[key] = obj[key];
        }
    });
    return result;
}
/**
 * 验证对象是否每个字段都满足条件，类似于数组的every方法，只是遍历的是对象自身的键
 * @param obj 对象
 * @param predicate 校验方法，接收对象自身键为参数，返回值为布尔值是否通过验证
 * @returns 是否所有字段都通过验证
 */
function every(obj, predicate) {
    let result = true;
    forEachOwnKey(obj, (key) => {
        if (!predicate(key)) {
            result = false;
        }
    });
    return result;
}
/**
 * 验证对象是否存在字段满足条件，类似于数组的some方法，只是遍历的是对象自身的键
 * @param obj 对象
 * @param predicate 校验方法，接收对象自身键为参数，返回值为布尔值是否通过验证
 * @returns 是否存在字段通过验证
 */
function some(obj, predicate) {
    let result = false;
    forEachOwnKey(obj, (key) => {
        if (predicate(key)) {
            result = true;
        }
    });
    return result;
}
/**
 * 对对象的每个字段执行回调，类似于数组的reduce方法，只是遍历的是对象自身的键
 * @param obj 对象
 * @param callback 执行的回调函数
 * @param initialValue 初始值
 * @returns 执行结果
 */
function reduce(obj, callback, initialValue) {
    let result = initialValue;
    forEachOwnKey(obj, (key) => {
        result = callback(result, key);
    });
    return result;
}
/**
 * 删除对象中的指定键值
 * @param obj 对象
 * @param keys 对象键值
 * @returns 去除给定键后的对象
 */
function omit(obj, keys) {
    return filter(obj, (key) => !keys.includes(key));
}

var ObjectUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    forEachOwnKey: forEachOwnKey,
    map: map,
    filter: filter,
    every: every,
    some: some,
    reduce: reduce,
    omit: omit
});

const BASE_ORIGIN = 'https://localhost';
/**
 * 根据给定的url创建URL对象，特别地，如果url中不包含origin，则会添加一个默认的origin防止报错并返回hasOrigin为false
 * @param url 源url
 * @returns URL对象
 * @example _createURL('https://www.xxx.com'); _createURL('/xx/xx');
 */
function _createURL(url) {
    let urlObj;
    let hasOrigin = true;
    try {
        urlObj = new URL(url);
    }
    catch {
        urlObj = new URL(url, BASE_ORIGIN);
        hasOrigin = false;
    }
    return {
        urlObj,
        hasOrigin,
    };
}
/**
 * 将对象作为参数添加到URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
function setObjToUrlParams(baseUrl, obj) {
    let parameters = '';
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
        }
    }
    parameters = parameters.replace(/&$/, '');
    return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}
/**
 * @description 解析url的search为对象
 * @export
 * @param {string} url
 * @returns Object
 */
function setUrlParamsToObj(url, lowerCase) {
    const usp = new URLSearchParams(url);
    const params = {};
    Array.from(usp.entries()).forEach(([key, value]) => {
        if (lowerCase) {
            params[key.toLowerCase()] = value;
        }
        else {
            params[key] = value;
        }
    });
    return params;
}
/**
 * 向url中添加query参数
 * @param baseUrl
 * @param obj
 * @returns
 */
function addUrlParams(baseUrl, obj) {
    const { urlObj, hasOrigin } = _createURL(baseUrl);
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            urlObj.searchParams.set(key, obj[key]);
        }
    }
    const resUrl = urlObj.toString();
    return hasOrigin ? resUrl : resUrl.slice(BASE_ORIGIN.length);
}
/**
 * 向url中添加路由参数
 * @param baseUrl
 * @param obj
 * @param isHashRouter 是否hash路由
 */
function addRouterQuery(baseUrl, obj, isHashRouter = false) {
    if (!Object.keys(obj).length) {
        return baseUrl;
    }
    if (!isHashRouter) {
        return addUrlParams(baseUrl, obj);
    }
    const hash = baseUrl.split('#')[1];
    if (!hash) {
        return `${baseUrl}#/${addObjToSearch('', obj, true)}`;
    }
    const hashQuery = hash.split('?')[1];
    if (!hashQuery) {
        return `${baseUrl}${addObjToSearch('', obj, true)}`;
    }
    return `${baseUrl}&${addObjToSearch('', obj)}`;
}
/**
 * 添加obj的key-value到给定search
 * @param source 源search
 * @param obj 要添加的对象
 * @param withPrefix 结果是否添加"?"前缀
 */
function addObjToSearch(source, obj, withPrefix = false) {
    const urlObj = new URLSearchParams(source);
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            urlObj.set(key, obj[key]);
        }
    }
    return withPrefix ? `?${urlObj.toString()}` : urlObj.toString();
}
/**
 * 将url中的http协议替换为https协议
 * @param url 链接地址
 * @returns 替换后的链接地址
 */
function replaceHttpWithHttps(url) {
    if (url === null || url.length === 0) {
        return '';
    }
    return url.replace(/^http:\/\//i, 'https://');
}
/**
 * 将路径中重复的正斜杠替换成单个斜杠隔开的字符串
 * @param path 要处理的路径
 * @returns 将/去重后的结果
 */
function uniqueSlash(path) {
    return path.replace(/(https?:\/)|(\/)+/g, '$1$2');
}
/** 获取当前域名的主域名 */
function getMainDomain() {
    return window.location.hostname.split('.').slice(-2).join('.');
}
/** 获取当前域名的二级域名 */
function getSubDomain() {
    return window.location.hostname.split('.')[0];
}
/**
 * 解析url中的query参数
 * @param url 要处理的路径
 * @param toLowerCase 结果key是否转小写
 * @param exclude 要排除的参数
 * @param ignoreCaseOnExclude 排除时是否忽略大小写
 * @param include 要包含的参数（此时exclude不生效）
 * @param ignoreCaseInInclude 包含时是否忽略大小写
 * @returns query参数对象
 */
function parseUrlParams(url, toLowerCase = false, exclude = [], ignoreCaseOnExclude = false, include, ignoreCaseOnInclude = false) {
    const urlObj = new URL(url);
    const usp = urlObj.searchParams;
    const params = Array.from(usp.entries()).reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {});
    const lowerCaseParams = reduce(params, (acc, key) => {
        acc[key.toLowerCase()] = params[key];
        return acc;
    }, {});
    if (include) {
        return include.reduce((acc, key) => {
            const lowerCaseKey = key.toLowerCase();
            const resKey = toLowerCase ? lowerCaseKey : key;
            const resValue = ignoreCaseOnInclude ? lowerCaseParams[lowerCaseKey] : params[key];
            acc[resKey] = resValue;
            return acc;
        }, {});
    }
    const lowerCaseExclude = exclude.map((key) => key.toLowerCase());
    return reduce(params, (acc, key) => {
        const lowerCaseKey = key.toLowerCase();
        const resKey = toLowerCase ? lowerCaseKey : key;
        if ((ignoreCaseOnExclude && !lowerCaseExclude.includes(lowerCaseKey)) ||
            (!ignoreCaseOnExclude && !exclude.includes(key))) {
            acc[resKey] = lowerCaseParams[lowerCaseKey];
        }
        return acc;
    }, {});
}
/**
 * 获取url中的指定参数值
 * @param url
 * @param key
 * @param ignoreCase
 * @returns
 */
function query(url, key, ignoreCase = false) {
    const params = setUrlParamsToObj(url, ignoreCase);
    const queryKey = ignoreCase ? key.toLowerCase() : key;
    return params[queryKey];
}

var Url = /*#__PURE__*/Object.freeze({
    __proto__: null,
    setObjToUrlParams: setObjToUrlParams,
    setUrlParamsToObj: setUrlParamsToObj,
    addUrlParams: addUrlParams,
    addRouterQuery: addRouterQuery,
    addObjToSearch: addObjToSearch,
    replaceHttpWithHttps: replaceHttpWithHttps,
    uniqueSlash: uniqueSlash,
    getMainDomain: getMainDomain,
    getSubDomain: getSubDomain,
    parseUrlParams: parseUrlParams,
    query: query
});

/**
 * 生成一个随机正数
 * @param max 最大值，默认值为9
 * @param min 最小值，默认值为0
 * @returns 一个最小值（包含）到最大值（包含）之间的随机正数
 */
function getRandomInteger(max = 9, min = 0) {
    if (max < min) {
        throw new Error('Get random integer invalid param: max should bigger than or equal to min');
    }
    return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * 生成一个随机大写英文字母
 * @returns 一个随机大写英文字母
 */
function getRandomUpperLetter() {
    return String.fromCharCode(getRandomInteger(25, 0) + 65);
}
/**
 * 生成一个随机小写英文字母
 * @returns 一个随机小写英文字母
 */
function getRandomLowerLetter() {
    return String.fromCharCode(getRandomInteger(25, 0) + 97);
}
/**
 * 生成一个可能为数字或英文字母的随机字符
 * @returns 一个随机字符
 */
function getRandomChar() {
    const generators = [getRandomInteger, getRandomLowerLetter, getRandomUpperLetter];
    return `${generators[getRandomInteger(2)]()}`;
}
/**
 * 生成指定长度的大写字母的随机字符串
 * @param length 长度
 * @returns 一个指定长度的大写字母的随机字符串
 */
function getRandomUpperLetterStr(length) {
    let ret = '';
    for (let i = 0; i < length; i++) {
        ret = `${ret}${getRandomUpperLetter()}`;
    }
    return ret;
}
/**
 * 生成指定长度的包含英文字母和数字的随机字符串
 * @param length 长度
 * @param containsAll 是否必定包含数字，大写字母和小写字母，默认值为true
 */
function getRandomStr(length, containsAll = true) {
    let ret = '';
    for (let i = 0; i < length; i++) {
        ret = `${ret}${getRandomChar()}`;
    }
    if (containsAll) {
        const all = `${getRandomInteger()}${getRandomLowerLetter()}${getRandomUpperLetter()}`;
        ret = `${ret.slice(0, length - 3)}${all}`;
    }
    return ret;
}
/**
 * 生成指定长度的仅包含小写英文字母的随机字符串
 * @param length 长度
 */
function getRandomLowerLetterStr(length = 8) {
    let ret = '';
    for (let i = 0; i < length; i++) {
        ret = `${ret}${getRandomLowerLetter()}`;
    }
    return ret;
}
/**
 * 生成长度为8的包含英文字母和数字的随机字符串
 * @param containsAll 是否必定包含数字，大写字母和小写字母，默认值为true
 */
function getRandom8(containsAll = true) {
    return getRandomStr(8, containsAll);
}
/** 生成随机Guid的模板 */
var BuiltInGuidTemplate;
(function (BuiltInGuidTemplate) {
    /** 通用模板 */
    BuiltInGuidTemplate["CommonId"] = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    /** 另一个通用模板，理论上来说没什么意义 */
    BuiltInGuidTemplate["FormId"] = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx";
    /** elementId */
    BuiltInGuidTemplate["ElementId"] = "xxxxxxxxxxxxxxxx";
})(BuiltInGuidTemplate || (BuiltInGuidTemplate = {}));
/**
 * 根据模板生成一个随机id，将模板中的x字符替换为随机的16进制字符，将模板中的y字符替换为[8, 9, 'a', 'b']中的随机一个
 * @param template 模板，默认值为'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
 * @returns 一个随机的id
 */
function getRandomGuid(template = BuiltInGuidTemplate.CommonId) {
    return template.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
function getRandomUUID() {
    return getRandomGuid().replaceAll('-', '');
}

var Random = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getRandomInteger: getRandomInteger,
    getRandomUpperLetter: getRandomUpperLetter,
    getRandomLowerLetter: getRandomLowerLetter,
    getRandomChar: getRandomChar,
    getRandomUpperLetterStr: getRandomUpperLetterStr,
    getRandomStr: getRandomStr,
    getRandomLowerLetterStr: getRandomLowerLetterStr,
    getRandom8: getRandom8,
    get BuiltInGuidTemplate () { return BuiltInGuidTemplate; },
    getRandomGuid: getRandomGuid,
    getRandomUUID: getRandomUUID
});

/**
 * 复制给定字符串到剪切板
 * @param text 要复制的字符串
 * @returns 一个复制成功时resolve的promise
 */
async function copyToClipboard(text) {
    try {
        // 先尝试使用clipboard API
        await navigator.clipboard.writeText(text);
    }
    catch {
        // 在body上生成一个input元素，赋值为要复制的值
        const input = document.createElement('input');
        input.setAttribute('style', 'position:fixed;top:-1000px;left:-1000px');
        input.value = text;
        document.body.appendChild(input);
        const isReadOnly = input.hasAttribute('readonly');
        if (!isReadOnly) {
            input.setAttribute('readonly', '');
        }
        // 选中元素内容并执行“复制”命令
        input.select();
        input.setSelectionRange(0, input.value.length);
        if (!isReadOnly) {
            input.removeAttribute('readonly');
        }
        document.execCommand('copy');
        // 移除元素
        document.body.removeChild(input);
    }
}

var Clipboard = /*#__PURE__*/Object.freeze({
    __proto__: null,
    copyToClipboard: copyToClipboard
});

/** 通过文件名获取文件扩展名 */
function getFileExtension(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex ? fileName.slice(lastDotIndex + 1).toLowerCase() : '';
}
/**
 * 下载文件
 * @param url 文件地址
 * @param name 下载文件名
 */
function downloadFile(url, name) {
    const a = document.createElement('a');
    a.href = url;
    if (name) {
        a.download = name;
    }
    a.target = '_self';
    a.click();
}
/**
 * 批量下载文件
 * @description 怎么这个好像会触发window上的beforeunload事件
 * @param url 下载地址
 * @param params 下载请求参数
 */
function batchDownloadFile(url, params) {
    // 构造form
    const $form = document.createElement('form');
    $form.action = url;
    $form.method = 'post';
    $form.onsubmit = () => false;
    $form.style.display = 'none';
    // 构造参数
    const $options = [];
    for (const key of Object.keys(params)) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            const $option = document.createElement('textarea');
            $option.name = key;
            $option.value = params[key];
            $options.push($option);
        }
    }
    // 触发下载
    $form.append(...$options);
    document.body.appendChild($form);
    $form.submit();
    document.body.removeChild($form);
}
/**
 * 格式化文件大小
 * @param size 文件大小（单位为字节）
 * @returns 格式化后的文件大小字符串
 */
function formatFileSize(size) {
    if (!size) {
        return '0KB';
    }
    const k = 1024;
    const p = 2;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(size) / Math.log(k));
    const num = size / Math.pow(k, i);
    return num.toFixed(p) + ' ' + sizes[i];
}

var File = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getFileExtension: getFileExtension,
    downloadFile: downloadFile,
    batchDownloadFile: batchDownloadFile,
    formatFileSize: formatFileSize
});

/** URL正则 */
const UrlRegExp = 
// eslint-disable-next-line no-useless-escape
/((https?:\/\/|ftp:\/\/)|(www\.))(localhost|[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(:\d+)?(\/[^\s?#]*)?(\?[^\s#]*)?(#\S*)?/g;
/** 邮箱正则 */
const EmailRegExp = 
// eslint-disable-next-line no-useless-escape
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// 手机号正则(登录、注册)
const MobileRegExp = /^(((0\d{2,3}-?)?\d{7,8})|((\+?86-?)?1[3456789]\d{9}))$/;
/** 密码正则(6-16为数字字母组合) */
const OldPasswordRegExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}/;
/** 密码正则(8-16位 必须包含字母和数字 可以输入特殊字符) */
const PasswordRegExp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}/;
// 手机号：1、输入位数不满11个数时 2、开头3位非正确，校验格式： 1 {3丨4丨5丨6丨7丨8丨9] + 数字 3、开头可以是+86-
// 固话：校验格式： 区号(0开头3-4位数字) + 电话号码(7-8位数字)， 可有可无分隔符号(-)
const TelephoneRegExp = /^(((\+?86-?)?1[3456789]\d{9})|((400-?)?\d{7,8})|((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})))$/;
// 身份证号正则
const IdentityCardExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
/** 系统内编码(表单/应用/引擎)的统一，如某种编码的特殊处理，单独在外面处理 */
const BaseCodeExp = '[a-zA-Z\\d_]+';
/** 带有global标志的emoji正则 */
const EmojiExpGlobal = /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g;
/** 特殊符号的正则 */
const SpecialCharExp = /[`~!@#$^&*()=|{}:'";,\\[\\].<>?~！@#￥……&*（）——|{}《》【】‘；：”“'。，、？%]/g;
/** 只允许中文+字母+数字 */
const CNLetterNumberExp = /[^a-zA-Z0-9\u4e00-\u9fff]/g;

var RegExpUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    UrlRegExp: UrlRegExp,
    EmailRegExp: EmailRegExp,
    MobileRegExp: MobileRegExp,
    OldPasswordRegExp: OldPasswordRegExp,
    PasswordRegExp: PasswordRegExp,
    TelephoneRegExp: TelephoneRegExp,
    IdentityCardExp: IdentityCardExp,
    BaseCodeExp: BaseCodeExp,
    EmojiExpGlobal: EmojiExpGlobal,
    SpecialCharExp: SpecialCharExp,
    CNLetterNumberExp: CNLetterNumberExp
});

/** 判断类型 */
function is(val, type) {
    return Object.prototype.toString.call(val) === `[object ${type}]`;
}
function isDef(val) {
    return typeof val !== 'undefined';
}
function isUnDef(val) {
    return !isDef(val);
}
function isObject(val) {
    return val !== null && is(val, 'Object');
}
function isEmpty(val) {
    if (isArray(val) || isString(val)) {
        return val.length === 0;
    }
    if (val instanceof Map || val instanceof Set) {
        return val.size === 0;
    }
    if (isObject(val)) {
        return Object.keys(val).length === 0;
    }
    return false;
}
function isEmptyUrl(val) {
    const _isNull = val === 'null' || val === null;
    const _isUnDef = val === 'undefined' || val === undefined;
    return _isNull || _isUnDef || val === '';
}
function isDate(val) {
    return is(val, 'Date');
}
function isNull(val) {
    return val === null;
}
function isNullAndUnDef(val) {
    return isUnDef(val) && isNull(val);
}
function isNullOrUnDef(val) {
    return isUnDef(val) || isNull(val);
}
function isNumber(val) {
    return is(val, 'Number');
}
function isNumeric(val) {
    return !Number.isNaN(parseFloat(val.toString())) && Number.isFinite(Number(val));
}
function isPromise(val) {
    return !!val && typeof val?.then === 'function';
}
function isString(val) {
    return is(val, 'String');
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(val) {
    return typeof val === 'function';
}
function isBoolean(val) {
    return is(val, 'Boolean');
}
function isRegExp(val) {
    return is(val, 'RegExp');
}
function isArray(val) {
    return Array.isArray(val);
}
function isWindow(val) {
    return typeof window !== 'undefined' && is(val, 'Window');
}
function isElement(val) {
    return isObject(val) && !!val.tagName;
}
function isMap(val) {
    return is(val, 'Map');
}
function isStringArray(val) {
    return isArray(val) && val.every((item) => isString(item));
}
const isServer = typeof window === 'undefined';
const isClient = !isServer;
/** 判断url 合理性 */
function isUrl(path) {
    const reg = new RegExp(UrlRegExp); // eslint-disable-line
    return reg.test(path);
}
/** 20221223合的 正则应该同is.ts放一块 */
/** 手机号 */
function isMobile(path) {
    const reg = new RegExp(MobileRegExp);
    return reg.test(path);
}
/** 密码 */
function isPassword(path) {
    const reg = new RegExp(PasswordRegExp);
    return reg.test(path);
}
/** 邮箱 */
function isEmail(path) {
    const reg = new RegExp(EmailRegExp);
    return reg.test(path);
}
/** 电话(手机号+固话) */
function isTelephone(path) {
    const reg = new RegExp(TelephoneRegExp);
    return reg.test(path);
}
/** 身份证号 */
function isIdentityCard(path) {
    const reg = new RegExp(IdentityCardExp);
    return reg.test(path);
}
/** ^(?!\d+$)表示开头之后，结尾之前不能是纯数字 目前编码规则只能是字母+数字/下划线 */
function isH3Code(path) {
    const reg = new RegExp(`^(?!\\d+$)${BaseCodeExp}$`);
    return reg.test(path);
}
/** 判断给定字符串是否是vue3标识符 */
function isVueReactiveFlags(key) {
    return ['__v_skip', '__v_isReactive', '__v_isReadonly', '__v_isShallow', '__v_raw'].includes(key);
}
/**
 * 判断给定字符串是否仅包含中文
 * @param str 任意字符串
 * @param emptyValue 传入空字符串的返回值
 */
function isChineseOnly(str, emptyValue = false) {
    if (!str) {
        return emptyValue;
    }
    return /^[\u4e00-\u9fa5]+$/.test(str);
}

var IS = /*#__PURE__*/Object.freeze({
    __proto__: null,
    is: is,
    isDef: isDef,
    isUnDef: isUnDef,
    isObject: isObject,
    isEmpty: isEmpty,
    isEmptyUrl: isEmptyUrl,
    isDate: isDate,
    isNull: isNull,
    isNullAndUnDef: isNullAndUnDef,
    isNullOrUnDef: isNullOrUnDef,
    isNumber: isNumber,
    isNumeric: isNumeric,
    isPromise: isPromise,
    isString: isString,
    isFunction: isFunction,
    isBoolean: isBoolean,
    isRegExp: isRegExp,
    isArray: isArray,
    isWindow: isWindow,
    isElement: isElement,
    isMap: isMap,
    isStringArray: isStringArray,
    isServer: isServer,
    isClient: isClient,
    isUrl: isUrl,
    isMobile: isMobile,
    isPassword: isPassword,
    isEmail: isEmail,
    isTelephone: isTelephone,
    isIdentityCard: isIdentityCard,
    isH3Code: isH3Code,
    isVueReactiveFlags: isVueReactiveFlags,
    isChineseOnly: isChineseOnly
});

/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */


// ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //


// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var MAX_DIGITS = 1e9,                        // 0 to 1e9


  // The initial configuration properties of the Decimal constructor.
  defaults = {

    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.

    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,                         // 1 to MAX_DIGITS

    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,                           // 0 to 8

    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,                          // 0 to -MAX_E

    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos:  21,                         // 0 to MAX_E

    // The natural logarithm of 10.
    // 115 digits
    LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
  },


// ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //


  Decimal,
  external = true,

  decimalError = '[DecimalError] ',
  invalidArgument = decimalError + 'Invalid argument: ',
  exponentOutOfRange = decimalError + 'Exponent out of range: ',

  mathfloor = Math.floor,
  mathpow = Math.pow,

  isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

  ONE,
  BASE = 1e7,
  LOG_BASE = 7,
  MAX_SAFE_INTEGER = 9007199254740991,
  MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284

  // Decimal.prototype object
  P = {};


// Decimal prototype methods


/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */


/*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */
P.absoluteValue = P.abs = function () {
  var x = new this.constructor(this);
  if (x.s) x.s = 1;
  return x;
};


/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */
P.comparedTo = P.cmp = function (y) {
  var i, j, xdL, ydL,
    x = this;

  y = new x.constructor(y);

  // Signs differ?
  if (x.s !== y.s) return x.s || -y.s;

  // Compare exponents.
  if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

  xdL = x.d.length;
  ydL = y.d.length;

  // Compare digit by digit.
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
  }

  // Compare lengths.
  return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
};


/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */
P.decimalPlaces = P.dp = function () {
  var x = this,
    w = x.d.length - 1,
    dp = (w - x.e) * LOG_BASE;

  // Subtract the number of trailing zeros of the last word.
  w = x.d[w];
  if (w) for (; w % 10 == 0; w /= 10) dp--;

  return dp < 0 ? 0 : dp;
};


/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */
P.dividedBy = P.div = function (y) {
  return divide(this, new this.constructor(y));
};


/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */
P.dividedToIntegerBy = P.idiv = function (y) {
  var x = this,
    Ctor = x.constructor;
  return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
};


/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */
P.equals = P.eq = function (y) {
  return !this.cmp(y);
};


/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */
P.exponent = function () {
  return getBase10Exponent(this);
};


/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */
P.greaterThan = P.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */
P.greaterThanOrEqualTo = P.gte = function (y) {
  return this.cmp(y) >= 0;
};


/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */
P.isInteger = P.isint = function () {
  return this.e > this.d.length - 2;
};


/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */
P.isNegative = P.isneg = function () {
  return this.s < 0;
};


/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */
P.isPositive = P.ispos = function () {
  return this.s > 0;
};


/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */
P.isZero = function () {
  return this.s === 0;
};


/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */
P.lessThan = P.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */
P.lessThanOrEqualTo = P.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */
P.logarithm = P.log = function (base) {
  var r,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision,
    wpr = pr + 5;

  // Default base is 10.
  if (base === void 0) {
    base = new Ctor(10);
  } else {
    base = new Ctor(base);

    // log[-b](x) = NaN
    // log[0](x)  = NaN
    // log[1](x)  = NaN
    if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
  }

  // log[b](-x) = NaN
  // log[b](0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // log[b](1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  external = false;
  r = divide(ln(x, wpr), ln(base, wpr), wpr);
  external = true;

  return round(r, pr);
};


/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */
P.minus = P.sub = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
};


/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */
P.modulo = P.mod = function (y) {
  var q,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision;

  y = new Ctor(y);

  // x % 0 = NaN
  if (!y.s) throw Error(decimalError + 'NaN');

  // Return x if x is 0.
  if (!x.s) return round(new Ctor(x), pr);

  // Prevent rounding of intermediate calculations.
  external = false;
  q = divide(x, y, 0, 1).times(y);
  external = true;

  return x.minus(q);
};


/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P.naturalExponential = P.exp = function () {
  return exp(this);
};


/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */
P.naturalLogarithm = P.ln = function () {
  return ln(this);
};


/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */
P.negated = P.neg = function () {
  var x = new this.constructor(this);
  x.s = -x.s || 0;
  return x;
};


/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */
P.plus = P.add = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
};


/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */
P.precision = P.sd = function (z) {
  var e, sd, w,
    x = this;

  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

  e = getBase10Exponent(x) + 1;
  w = x.d.length - 1;
  sd = w * LOG_BASE + 1;
  w = x.d[w];

  // If non-zero...
  if (w) {

    // Subtract the number of trailing zeros of the last word.
    for (; w % 10 == 0; w /= 10) sd--;

    // Add the number of digits of the first word.
    for (w = x.d[0]; w >= 10; w /= 10) sd++;
  }

  return z && e > sd ? e : sd;
};


/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P.squareRoot = P.sqrt = function () {
  var e, n, pr, r, s, t, wpr,
    x = this,
    Ctor = x.constructor;

  // Negative or zero?
  if (x.s < 1) {
    if (!x.s) return new Ctor(0);

    // sqrt(-x) = NaN
    throw Error(decimalError + 'NaN');
  }

  e = getBase10Exponent(x);
  external = false;

  // Initial estimate.
  s = Math.sqrt(+x);

  // Math.sqrt underflow/overflow?
  // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(x.d);
    if ((n.length + e) % 2 == 0) n += '0';
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

    if (s == 1 / 0) {
      n = '5e' + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf('e') + 1) + e;
    }

    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }

  pr = Ctor.precision;
  s = wpr = pr + 3;

  // Newton-Raphson iteration.
  for (;;) {
    t = r;
    r = t.plus(divide(x, t, wpr + 2)).times(0.5);

    if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
      n = n.slice(wpr - 3, wpr + 1);

      // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
      // 4999, i.e. approaching a rounding boundary, continue the iteration.
      if (s == wpr && n == '4999') {

        // On the first iteration only, check to see if rounding up gives the exact result as the
        // nines may infinitely repeat.
        round(t, pr + 1, 0);

        if (t.times(t).eq(x)) {
          r = t;
          break;
        }
      } else if (n != '9999') {
        break;
      }

      wpr += 4;
    }
  }

  external = true;

  return round(r, pr);
};


/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */
P.times = P.mul = function (y) {
  var carry, e, i, k, r, rL, t, xdL, ydL,
    x = this,
    Ctor = x.constructor,
    xd = x.d,
    yd = (y = new Ctor(y)).d;

  // Return 0 if either is 0.
  if (!x.s || !y.s) return new Ctor(0);

  y.s *= x.s;
  e = x.e + y.e;
  xdL = xd.length;
  ydL = yd.length;

  // Ensure xd points to the longer array.
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }

  // Initialise the result array with zeros.
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--;) r.push(0);

  // Multiply!
  for (i = ydL; --i >= 0;) {
    carry = 0;
    for (k = xdL + i; k > i;) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = t / BASE | 0;
    }

    r[k] = (r[k] + carry) % BASE | 0;
  }

  // Remove trailing zeros.
  for (; !r[--rL];) r.pop();

  if (carry) ++e;
  else r.shift();

  y.d = r;
  y.e = e;

  return external ? round(y, Ctor.precision) : y;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toDecimalPlaces = P.todp = function (dp, rm) {
  var x = this,
    Ctor = x.constructor;

  x = new Ctor(x);
  if (dp === void 0) return x;

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  return round(x, dp + getBase10Exponent(x) + 1, rm);
};


/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toExponential = function (dp, rm) {
  var str,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) {
    str = toString(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round(new Ctor(x), dp + 1, rm);
    str = toString(x, true, dp + 1);
  }

  return str;
};


/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */
P.toFixed = function (dp, rm) {
  var str, y,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) return toString(x);

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
  str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

  // To determine whether to add the minus sign look at the value before it was rounded,
  // i.e. look at `x` rather than `y`.
  return x.isneg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */
P.toInteger = P.toint = function () {
  var x = this,
    Ctor = x.constructor;
  return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
};


/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */
P.toNumber = function () {
  return +this;
};


/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */
P.toPower = P.pow = function (y) {
  var e, k, pr, r, sign, yIsInt,
    x = this,
    Ctor = x.constructor,
    guard = 12,
    yn = +(y = new Ctor(y));

  // pow(x, 0) = 1
  if (!y.s) return new Ctor(ONE);

  x = new Ctor(x);

  // pow(0, y > 0) = 0
  // pow(0, y < 0) = Infinity
  if (!x.s) {
    if (y.s < 1) throw Error(decimalError + 'Infinity');
    return x;
  }

  // pow(1, y) = 1
  if (x.eq(ONE)) return x;

  pr = Ctor.precision;

  // pow(x, 1) = x
  if (y.eq(ONE)) return round(x, pr);

  e = y.e;
  k = y.d.length - 1;
  yIsInt = e >= k;
  sign = x.s;

  if (!yIsInt) {

    // pow(x < 0, y non-integer) = NaN
    if (sign < 0) throw Error(decimalError + 'NaN');

  // If y is a small integer use the 'exponentiation by squaring' algorithm.
  } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
    r = new Ctor(ONE);

    // Max k of 9007199254740991 takes 53 loop iterations.
    // Maximum digits array length; leaves [28, 34] guard digits.
    e = Math.ceil(pr / LOG_BASE + 4);

    external = false;

    for (;;) {
      if (k % 2) {
        r = r.times(x);
        truncate(r.d, e);
      }

      k = mathfloor(k / 2);
      if (k === 0) break;

      x = x.times(x);
      truncate(x.d, e);
    }

    external = true;

    return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
  }

  // Result is negative if x is negative and the last digit of integer y is odd.
  sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

  x.s = 1;
  external = false;
  r = y.times(ln(x, pr + guard));
  external = true;
  r = exp(r);
  r.s = sign;

  return r;
};


/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toPrecision = function (sd, rm) {
  var e, str,
    x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    e = getBase10Exponent(x);
    str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round(new Ctor(x), sd, rm);
    e = getBase10Exponent(x);
    str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
  }

  return str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P.toSignificantDigits = P.tosd = function (sd, rm) {
  var x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }

  return round(new Ctor(x), sd, rm);
};


/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */
P.toString = P.valueOf = P.val = P.toJSON = P[Symbol.for('nodejs.util.inspect.custom')] = function () {
  var x = this,
    e = getBase10Exponent(x),
    Ctor = x.constructor;

  return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};


// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */


function add(x, y) {
  var carry, d, e, i, k, len, xd, yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // If either is zero...
  if (!x.s || !y.s) {

    // Return x if y is zero.
    // Return y if y is non-zero.
    if (!y.s) y = new Ctor(x);
    return external ? round(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are finite, non-zero numbers with the same sign.

  k = x.e;
  e = y.e;
  xd = xd.slice();
  i = k - e;

  // If base 1e7 exponents differ...
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }

    // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;

    if (i > len) {
      i = len;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
    d.reverse();
    for (; i--;) d.push(0);
    d.reverse();
  }

  len = xd.length;
  i = yd.length;

  // If yd is longer than xd, swap xd and yd so xd points to the longer array.
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }

  // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
  for (carry = 0; i;) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }

  if (carry) {
    xd.unshift(carry);
    ++e;
  }

  // Remove trailing zeros.
  // No need to check for zero, as +x + +y != 0 && -x + -y != 0
  for (len = xd.length; xd[--len] == 0;) xd.pop();

  y.d = xd;
  y.e = e;

  return external ? round(y, pr) : y;
}


function checkInt32(i, min, max) {
  if (i !== ~~i || i < min || i > max) {
    throw Error(invalidArgument + i);
  }
}


function digitsToString(d) {
  var i, k, ws,
    indexOfLastWord = d.length - 1,
    str = '',
    w = d[0];

  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }

    w = d[i];
    ws = w + '';
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return '0';
  }

  // Remove trailing zeros of last w.
  for (; w % 10 === 0;) w /= 10;

  return str + w;
}


var divide = (function () {

  // Assumes non-zero x and k, and hence non-zero result.
  function multiplyInteger(x, k) {
    var temp,
      carry = 0,
      i = x.length;

    for (x = x.slice(); i--;) {
      temp = x[i] * k + carry;
      x[i] = temp % BASE | 0;
      carry = temp / BASE | 0;
    }

    if (carry) x.unshift(carry);

    return x;
  }

  function compare(a, b, aL, bL) {
    var i, r;

    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }

    return r;
  }

  function subtract(a, b, aL) {
    var i = 0;

    // Subtract b from a.
    for (; aL--;) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * BASE + a[aL] - b[aL];
    }

    // Remove leading zeros.
    for (; !a[0] && a.length > 1;) a.shift();
  }

  return function (x, y, pr, dp) {
    var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
      Ctor = x.constructor,
      sign = x.s == y.s ? 1 : -1,
      xd = x.d,
      yd = y.d;

    // Either 0?
    if (!x.s) return new Ctor(x);
    if (!y.s) throw Error(decimalError + 'Division by zero');

    e = x.e - y.e;
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign);
    qd = q.d = [];

    // Result exponent may be one less than e.
    for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
    if (yd[i] > (xd[i] || 0)) --e;

    if (pr == null) {
      sd = pr = Ctor.precision;
    } else if (dp) {
      sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
    } else {
      sd = pr;
    }

    if (sd < 0) return new Ctor(0);

    // Convert precision in number of base 10 digits to base 1e7 digits.
    sd = sd / LOG_BASE + 2 | 0;
    i = 0;

    // divisor < 1e7
    if (yL == 1) {
      k = 0;
      yd = yd[0];
      sd++;

      // k is the carry.
      for (; (i < xL || k) && sd--; i++) {
        t = k * BASE + (xd[i] || 0);
        qd[i] = t / yd | 0;
        k = t % yd | 0;
      }

    // divisor >= 1e7
    } else {

      // Normalise xd and yd so highest order digit of yd is >= BASE/2
      k = BASE / (yd[0] + 1) | 0;

      if (k > 1) {
        yd = multiplyInteger(yd, k);
        xd = multiplyInteger(xd, k);
        yL = yd.length;
        xL = xd.length;
      }

      xi = yL;
      rem = xd.slice(0, yL);
      remL = rem.length;

      // Add zeros to make remainder as long as divisor.
      for (; remL < yL;) rem[remL++] = 0;

      yz = yd.slice();
      yz.unshift(0);
      yd0 = yd[0];

      if (yd[1] >= BASE / 2) ++yd0;

      do {
        k = 0;

        // Compare divisor and remainder.
        cmp = compare(yd, rem, yL, remL);

        // If divisor < remainder.
        if (cmp < 0) {

          // Calculate trial digit, k.
          rem0 = rem[0];
          if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

          // k will be how many times the divisor goes into the current remainder.
          k = rem0 / yd0 | 0;

          //  Algorithm:
          //  1. product = divisor * trial digit (k)
          //  2. if product > remainder: product -= divisor, k--
          //  3. remainder -= product
          //  4. if product was < remainder at 2:
          //    5. compare new remainder and divisor
          //    6. If remainder > divisor: remainder -= divisor, k++

          if (k > 1) {
            if (k >= BASE) k = BASE - 1;

            // product = divisor * trial digit.
            prod = multiplyInteger(yd, k);
            prodL = prod.length;
            remL = rem.length;

            // Compare product and remainder.
            cmp = compare(prod, rem, prodL, remL);

            // product > remainder.
            if (cmp == 1) {
              k--;

              // Subtract divisor from product.
              subtract(prod, yL < prodL ? yz : yd, prodL);
            }
          } else {

            // cmp is -1.
            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
            if (k == 0) cmp = k = 1;
            prod = yd.slice();
          }

          prodL = prod.length;
          if (prodL < remL) prod.unshift(0);

          // Subtract product from remainder.
          subtract(rem, prod, remL);

          // If product was < previous remainder.
          if (cmp == -1) {
            remL = rem.length;

            // Compare divisor and new remainder.
            cmp = compare(yd, rem, yL, remL);

            // If divisor < new remainder, subtract divisor from remainder.
            if (cmp < 1) {
              k++;

              // Subtract divisor from remainder.
              subtract(rem, yL < remL ? yz : yd, remL);
            }
          }

          remL = rem.length;
        } else if (cmp === 0) {
          k++;
          rem = [0];
        }    // if cmp === 1, k will be 0

        // Add the next digit, k, to the result array.
        qd[i++] = k;

        // Update the remainder.
        if (cmp && rem[0]) {
          rem[remL++] = xd[xi] || 0;
        } else {
          rem = [xd[xi]];
          remL = 1;
        }

      } while ((xi++ < xL || rem[0] !== void 0) && sd--);
    }

    // Leading zero?
    if (!qd[0]) qd.shift();

    q.e = e;

    return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
  };
})();


/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */
function exp(x, sd) {
  var denominator, guard, pow, sum, t, wpr,
    i = 0,
    k = 0,
    Ctor = x.constructor,
    pr = Ctor.precision;

  if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

  // exp(0) = 1
  if (!x.s) return new Ctor(ONE);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  t = new Ctor(0.03125);

  while (x.abs().gte(0.1)) {
    x = x.times(t);    // x = x / 2^5
    k += 5;
  }

  // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
  guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow = sum = new Ctor(ONE);
  Ctor.precision = wpr;

  for (;;) {
    pow = round(pow.times(x), wpr);
    denominator = denominator.times(++i);
    t = sum.plus(divide(pow, denominator, wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      while (k--) sum = round(sum.times(sum), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum, pr)) : sum;
    }

    sum = t;
  }
}


// Calculate the base 10 exponent from the base 1e7 exponent.
function getBase10Exponent(x) {
  var e = x.e * LOG_BASE,
    w = x.d[0];

  // Add the number of digits of the first word of the digits array.
  for (; w >= 10; w /= 10) e++;
  return e;
}


function getLn10(Ctor, sd, pr) {

  if (sd > Ctor.LN10.sd()) {


    // Reset global state in case the exception is caught.
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(decimalError + 'LN10 precision limit exceeded');
  }

  return round(new Ctor(Ctor.LN10), sd);
}


function getZeroString(k) {
  var zs = '';
  for (; k--;) zs += '0';
  return zs;
}


/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */
function ln(y, sd) {
  var c, c0, denominator, e, numerator, sum, t, wpr, x2,
    n = 1,
    guard = 10,
    x = y,
    xd = x.d,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // ln(-x) = NaN
  // ln(0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // ln(1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  if (x.eq(10)) {
    if (sd == null) external = true;
    return getLn10(Ctor, wpr);
  }

  wpr += guard;
  Ctor.precision = wpr;
  c = digitsToString(xd);
  c0 = c.charAt(0);
  e = getBase10Exponent(x);

  if (Math.abs(e) < 1.5e15) {

    // Argument reduction.
    // The series converges faster the closer the argument is to 1, so using
    // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
    // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
    // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
    // later be divided by this number, then separate out the power of 10 using
    // ln(a*10^b) = ln(a) + b*ln(10).

    // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
    //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
    // max n is 6 (gives 0.7 - 1.3)
    while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }

    e = getBase10Exponent(x);

    if (c0 > 1) {
      x = new Ctor('0.' + c);
      e++;
    } else {
      x = new Ctor(c0 + '.' + c.slice(1));
    }
  } else {

    // The argument reduction method above may result in overflow if the argument y is a massive
    // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
    // function using ln(x*10^e) = ln(x) + e*ln(10).
    t = getLn10(Ctor, wpr + 2, pr).times(e + '');
    x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

    Ctor.precision = pr;
    return sd == null ? (external = true, round(x, pr)) : x;
  }

  // x is reduced to a value near 1.

  // Taylor series.
  // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
  // where x = (y - 1)/(y + 1)    (|x| < 1)
  sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
  x2 = round(x.times(x), wpr);
  denominator = 3;

  for (;;) {
    numerator = round(numerator.times(x2), wpr);
    t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      sum = sum.times(2);

      // Reverse the argument reduction.
      if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
      sum = divide(sum, new Ctor(n), wpr);

      Ctor.precision = pr;
      return sd == null ? (external = true, round(sum, pr)) : sum;
    }

    sum = t;
    denominator += 2;
  }
}


/*
 * Parse the value of a new Decimal `x` from string `str`.
 */
function parseDecimal(x, str) {
  var e, i, len;

  // Decimal point?
  if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

  // Exponential form?
  if ((i = str.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = str.length;
  }

  // Determine leading zeros.
  for (i = 0; str.charCodeAt(i) === 48;) ++i;

  // Determine trailing zeros.
  for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
  str = str.slice(i, len);

  if (str) {
    len -= i;
    e = e - i - 1;
    x.e = mathfloor(e / LOG_BASE);
    x.d = [];

    // Transform base

    // e is the base 10 exponent.
    // i is where to slice str to get the first word of the digits array.
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;

    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }

    for (; i--;) str += '0';
    x.d.push(+str);

    if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
  } else {

    // Zero.
    x.s = 0;
    x.e = 0;
    x.d = [0];
  }

  return x;
}


/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */
 function round(x, sd, rm) {
  var i, j, k, n, rd, doRound, w, xdi,
    xd = x.d;

  // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
  // w: the word of xd which contains the rounding digit, a base 1e7 number.
  // xdi: the index of w within xd.
  // n: the number of digits of w.
  // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
  // they had leading zeros)
  // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

  // Get the length of the first word of the digits array xd.
  for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
  i = sd - n;

  // Is the rounding digit in the first word of xd?
  if (i < 0) {
    i += LOG_BASE;
    j = sd;
    w = xd[xdi = 0];
  } else {
    xdi = Math.ceil((i + 1) / LOG_BASE);
    k = xd.length;
    if (xdi >= k) return x;
    w = k = xd[xdi];

    // Get the number of digits of w.
    for (n = 1; k >= 10; k /= 10) n++;

    // Get the index of rd within w.
    i %= LOG_BASE;

    // Get the index of rd within w, adjusted for leading zeros.
    // The number of leading zeros of w is given by LOG_BASE - n.
    j = i - LOG_BASE + n;
  }

  if (rm !== void 0) {
    k = mathpow(10, n - j - 1);

    // Get the rounding digit at index j of w.
    rd = w / k % 10 | 0;

    // Are there any non-zero digits after the rounding digit?
    doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

    // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
    // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
    // 714.

    doRound = rm < 4
      ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
      : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

        // Check whether the digit to the left of the rounding digit is odd.
        ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
          rm == (x.s < 0 ? 8 : 7));
  }

  if (sd < 1 || !xd[0]) {
    if (doRound) {
      k = getBase10Exponent(x);
      xd.length = 1;

      // Convert sd to decimal places.
      sd = sd - k - 1;

      // 1, 0.1, 0.01, 0.001, 0.0001 etc.
      xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
      x.e = mathfloor(-sd / LOG_BASE) || 0;
    } else {
      xd.length = 1;

      // Zero.
      xd[0] = x.e = x.s = 0;
    }

    return x;
  }

  // Remove excess digits.
  if (i == 0) {
    xd.length = xdi;
    k = 1;
    xdi--;
  } else {
    xd.length = xdi + 1;
    k = mathpow(10, LOG_BASE - i);

    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
    // j > 0 means i > number of leading zeros of w.
    xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
  }

  if (doRound) {
    for (;;) {

      // Is the digit to be rounded up in the first word of xd?
      if (xdi == 0) {
        if ((xd[0] += k) == BASE) {
          xd[0] = 1;
          ++x.e;
        }

        break;
      } else {
        xd[xdi] += k;
        if (xd[xdi] != BASE) break;
        xd[xdi--] = 0;
        k = 1;
      }
    }
  }

  // Remove trailing zeros.
  for (i = xd.length; xd[--i] === 0;) xd.pop();

  if (external && (x.e > MAX_E || x.e < -MAX_E)) {
    throw Error(exponentOutOfRange + getBase10Exponent(x));
  }

  return x;
}


function subtract(x, y) {
  var d, e, i, j, k, len, xd, xe, xLTy, yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // Return y negated if x is zero.
  // Return x if y is zero and x is non-zero.
  if (!x.s || !y.s) {
    if (y.s) y.s = -y.s;
    else y = new Ctor(x);
    return external ? round(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are non-zero numbers with the same sign.

  e = y.e;
  xe = x.e;
  xd = xd.slice();
  k = xe - e;

  // If exponents differ...
  if (k) {
    xLTy = k < 0;

    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }

    // Numbers with massively different exponents would result in a very high number of zeros
    // needing to be prepended, but this can be avoided while still ensuring correct rounding by
    // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

    if (k > i) {
      k = i;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents.
    d.reverse();
    for (i = k; i--;) d.push(0);
    d.reverse();

  // Base 1e7 exponents equal.
  } else {

    // Check digits to determine which is the bigger number.

    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;

    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }

    k = 0;
  }

  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }

  len = xd.length;

  // Append zeros to xd if shorter.
  // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

  // Subtract yd from xd.
  for (i = yd.length; i > k;) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }

    xd[i] -= yd[i];
  }

  // Remove trailing zeros.
  for (; xd[--len] === 0;) xd.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xd[0] === 0; xd.shift()) --e;

  // Zero?
  if (!xd[0]) return new Ctor(0);

  y.d = xd;
  y.e = e;

  //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
  return external ? round(y, pr) : y;
}


function toString(x, isExp, sd) {
  var k,
    e = getBase10Exponent(x),
    str = digitsToString(x.d),
    len = str.length;

  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + '.' + str.slice(1);
    }

    str = str + (e < 0 ? 'e' : 'e+') + e;
  } else if (e < 0) {
    str = '0.' + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += '.';
      str += getZeroString(k);
    }
  }

  return x.s < 0 ? '-' + str : str;
}


// Does not strip trailing zeros.
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}


// Decimal methods


/*
 *  clone
 *  config/set
 */


/*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */
function clone(obj) {
  var i, p, ps;

  /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */
  function Decimal(value) {
    var x = this;

    // Decimal called without new.
    if (!(x instanceof Decimal)) return new Decimal(value);

    // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
    // which points to Object.
    x.constructor = Decimal;

    // Duplicate.
    if (value instanceof Decimal) {
      x.s = value.s;
      x.e = value.e;
      x.d = (value = value.d) ? value.slice() : value;
      return;
    }

    if (typeof value === 'number') {

      // Reject Infinity/NaN.
      if (value * 0 !== 0) {
        throw Error(invalidArgument + value);
      }

      if (value > 0) {
        x.s = 1;
      } else if (value < 0) {
        value = -value;
        x.s = -1;
      } else {
        x.s = 0;
        x.e = 0;
        x.d = [0];
        return;
      }

      // Fast path for small integers.
      if (value === ~~value && value < 1e7) {
        x.e = 0;
        x.d = [value];
        return;
      }

      return parseDecimal(x, value.toString());
    } else if (typeof value !== 'string') {
      throw Error(invalidArgument + value);
    }

    // Minus sign?
    if (value.charCodeAt(0) === 45) {
      value = value.slice(1);
      x.s = -1;
    } else {
      x.s = 1;
    }

    if (isDecimal.test(value)) parseDecimal(x, value);
    else throw Error(invalidArgument + value);
  }

  Decimal.prototype = P;

  Decimal.ROUND_UP = 0;
  Decimal.ROUND_DOWN = 1;
  Decimal.ROUND_CEIL = 2;
  Decimal.ROUND_FLOOR = 3;
  Decimal.ROUND_HALF_UP = 4;
  Decimal.ROUND_HALF_DOWN = 5;
  Decimal.ROUND_HALF_EVEN = 6;
  Decimal.ROUND_HALF_CEIL = 7;
  Decimal.ROUND_HALF_FLOOR = 8;

  Decimal.clone = clone;
  Decimal.config = Decimal.set = config;

  if (obj === void 0) obj = {};
  if (obj) {
    ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
    for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
  }

  Decimal.config(obj);

  return Decimal;
}


/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */
function config(obj) {
  if (!obj || typeof obj !== 'object') {
    throw Error(decimalError + 'Object expected');
  }
  var i, p, v,
    ps = [
      'precision', 1, MAX_DIGITS,
      'rounding', 0, 8,
      'toExpNeg', -1 / 0, 0,
      'toExpPos', 0, 1 / 0
    ];

  for (i = 0; i < ps.length; i += 3) {
    if ((v = obj[p = ps[i]]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ': ' + v);
    }
  }

  if ((v = obj[p = 'LN10']) !== void 0) {
      if (v == Math.LN10) this[p] = new this(v);
      else throw Error(invalidArgument + p + ': ' + v);
  }

  return this;
}


// Create and configure initial Decimal constructor.
var Decimal = clone(defaults);

// Internal constant.
ONE = new Decimal(1);

var Decimal$1 = Decimal;

Decimal$1.set({ precision: 40 });
/** 是否是false */
function isFalsy(val) {
    const isFalsyNumber = typeof val === 'number' && Number.isNaN(val);
    if (val === null || val === undefined || val === '' || isFalsyNumber) {
        return true;
    }
    return false;
}
/**
 * 向数字中添加千分位分隔符
 * @param num 数值
 * @returns 添加千分位分隔符后的数值
 */
function numberToThousands(num) {
    const numStr = num.toString().split('.');
    let tmpNum = numStr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    if (numStr.length > 1) {
        tmpNum += `.${numStr[1]}`;
    }
    return tmpNum;
}
/**
 * 将数值转换为百分比值（乘以100）
 * @param num 数值
 * @param defaultVal 转换错误时的默认值，默认为空字符串
 */
function numberToPercentage(num, defaultVal = '') {
    let result;
    try {
        // 倍数
        const m = 100;
        result = new Decimal$1(num).times(m).toString();
    }
    catch {
        result = defaultVal;
    }
    return result;
}
/**
 * 将百分比值转换为数值（除以100）
 * @param num 百分比值
 * @param defaultVal 转换错误时的默认值，默认为空字符串
 */
function percentageToNumber(num, defaultVal = '') {
    let result;
    try {
        // 倍数
        const m = 100;
        result = new Decimal$1(num).div(m).toString();
    }
    catch {
        result = defaultVal;
    }
    return result;
}
/**
 * 将数值补充至指定小数位数(截取)
 * @param value 数值
 * @param decimalPlaces 小数位数
 * @param defaultVal 转换错误时的默认值，默认为空字符串
 */
function toFixed(value, decimalPlaces, defaultVal = '') {
    let result;
    try {
        const standardizedDecimalPlaces = Math.max(0, decimalPlaces || 0);
        result = new Decimal$1(value).toFixed(standardizedDecimalPlaces, Decimal$1.ROUND_HALF_UP);
        if (Number(result) === 0) {
            result = '0';
        }
    }
    catch {
        result = defaultVal;
    }
    return result;
}
/**
 * 将传入的值转换为数值或空
 * @param value 处理的值
 * @returns 转换后的值
 */
function parseToNumber(value) {
    let result = `${value}`.trim();
    // 处理科学计数法格式
    const scientificNotationRegex = /^[-+]?(?:\d+\.?\d*|\.\d+)[eE][-+]?\d+$/;
    if (scientificNotationRegex.test(result)) {
        try {
            // 使用 Decimal.js 解析科学计数法
            return new Decimal$1(result).toString();
        }
        catch {
            // 如果解析失败，继续使用原有逻辑处理
        }
    }
    // 去掉".", "-"和数字以外的字符
    result = result.replace(/[^\d.-]/g, '');
    // 暂存符号位，去掉所有的"-"
    const symbol = result[0] === '-' ? '-' : '';
    result = result.replace(/-/g, '');
    // 只保留第一个"."，并补充小数点前的0
    result = result
        .replace(/\.{2,}/g, '.')
        .split('.')
        .reduce((prev, curr, index) => {
        if (index === 1) {
            return `${prev || 0}.${curr}`;
        }
        return `${prev}${curr}`;
    }, '');
    // 补齐符号位
    if (result.length) {
        result = `${symbol}${result}`;
    }
    return result;
}

var NumberUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isFalsy: isFalsy,
    numberToThousands: numberToThousands,
    numberToPercentage: numberToPercentage,
    percentageToNumber: percentageToNumber,
    toFixed: toFixed,
    parseToNumber: parseToNumber
});

/**
 * 将给定字符串的首字母转换为指定格式
 * @param char 被转换的字符串
 * @param type 转换的类型（大写或小写）
 * @returns 转换结果
 */
const firstLetterCaseConversion = function (char, type) {
    if (!char) {
        return '';
    }
    const firstLetter = type === 'lower' ? char[0].toLowerCase() : char[0].toUpperCase();
    return firstLetter + char.slice(1);
};
/**
 * 过滤掉字符串中的emoji表情
 * @param str 被过滤的字符串
 */
function filterEmoji(str) {
    return str.replace(EmojiExpGlobal, '');
}
/**
 * 过滤掉字符串中的特殊符号
 * @param str 被过滤的字符串
 * @returns 过滤后的字符串
 */
function filterSpecial(str) {
    // 如果 str 为 null，默认值为空字符串
    return str.replace(SpecialCharExp, '');
}
function safeCompressHTML(html) {
    try {
        // 保留 pre/code/textarea 中的内容
        const preservedBlocks = [];
        let index = 0;
        // 暂存需要保护的内容
        html = html.replace(/<(pre|code|textarea)[^>]*>[\s\S]*?<\/\1>/gi, (match) => {
            preservedBlocks.push(match);
            return `__PRESERVED_${index++}__`;
        });
        // 压缩剩余部分
        html = html.replace(/>\s+</g, '><').replace(/\n/g, '');
        // 恢复被保护的内容
        return html.replace(/__PRESERVED_(\d+)__/g, (_, id) => preservedBlocks[id]);
    }
    catch {
        return html;
    }
}
/**
 * 模糊搜索匹配
 * @param keyword 搜索关键词
 * @param target 目标字符
 * @returns boolean
 */
function fuzzySearch(keyword, target) {
    const terms = keyword.split(/\s+/);
    // 检查目标字符串是否包含所有搜索词
    return terms.every((term) => target.includes(term));
}
/**
 * 获取最后的字符
 * @param target 目标字符 'aaaaa.bbbbb.ccccc'
 * @returns 目标字符
 */
function getLastChar(target) {
    const list = target.split('.');
    return list?.[list.length - 1];
}

var Char = /*#__PURE__*/Object.freeze({
    __proto__: null,
    firstLetterCaseConversion: firstLetterCaseConversion,
    filterEmoji: filterEmoji,
    filterSpecial: filterSpecial,
    safeCompressHTML: safeCompressHTML,
    fuzzySearch: fuzzySearch,
    getLastChar: getLastChar
});

/**
 * 封装过的JSON.stringify函数，拦截了异常
 * @param value 要序列化的值
 * @param defaultVal 序列化异常时返回的默认值，默认为空字符串
 * @param replacer JSON.stringify函数第二个参数
 * @param space JSON.stringify函数第三个参数
 * @returns 序列化后的值
 */
function stringify(value, defaultVal = '', replacer, space) {
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (e) {
        return defaultVal;
    }
}
function parse(text, defaultVal = null, reviver) {
    try {
        return JSON.parse(text, reviver);
    }
    catch (e) {
        return defaultVal;
    }
}
// 是否是一个合法的JSON字符串
function isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    }
    catch (e) {
        return false;
    }
}

var JSONUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    stringify: stringify,
    parse: parse,
    isValidJSON: isValidJSON
});

/** 用于窗口自动聚焦的元素 */
let $windowFocusEl;
/**
 * 窗口自动聚焦
 */
function focusWindow() {
    if (!$windowFocusEl) {
        $windowFocusEl = document.createElement('input');
        $windowFocusEl.setAttribute('type', 'text');
        $windowFocusEl.setAttribute('style', 'position: fixed; top: -1000px; left: -1000px');
        document.body.appendChild($windowFocusEl);
    }
    $windowFocusEl.focus();
}
/**
 * 阻止事件默认行为
 * @description 旧代码中的逻辑，看起来是兼容性代码，理论上在现代浏览器中不需要
 * @param e 事件
 */
function preventEventDefault(e) {
    if (e && e.preventDefault) {
        e.preventDefault();
        return;
    }
    if (window.event) {
        window.event.returnValue = false;
    }
}
function loadScript(src) {
    return new Promise((resolve, reject) => {
        // 创建script元素
        const script = document.createElement('script');
        script.src = src;
        // script.defer = true;
        // 成功加载处理
        script.onload = () => resolve(`脚本加载成功: ${src}`);
        // 错误处理
        script.onerror = () => reject(new Error(`脚本加载失败: ${src}`));
        // 添加到DOM
        document.head.appendChild(script);
    });
}

var Dom = /*#__PURE__*/Object.freeze({
    __proto__: null,
    focusWindow: focusWindow,
    preventEventDefault: preventEventDefault,
    loadScript: loadScript
});

/**
 * 解析jwt令牌中的业务信息
 * @param token jwt令牌
 */
function parseToken(token) {
    try {
        const bizContentBase64 = token.split('.')[1];
        return JSON.parse(window.atob(bizContentBase64));
    }
    catch (err) {
        return {};
    }
}

var Token = /*#__PURE__*/Object.freeze({
    __proto__: null,
    parseToken: parseToken
});

/** 事件总线 */
class EventBus {
    _eventMap;
    constructor() {
        this._eventMap = new Map();
    }
    /**
     * 清空所有注册的回调
     */
    init() {
        this._eventMap.clear();
    }
    /**
     * 发布事件，触发注册的回调函数
     * @param name 事件名称
     * @param args 传递给回调函数的参数
     * @returns 是否有回调函数被触发
     */
    emit(name, ...args) {
        const callbacks = this._eventMap.get(name);
        if (!callbacks || callbacks.length === 0) {
            return false;
        }
        callbacks.forEach((callback) => callback.call(null, ...args));
        return true;
    }
    /**
     * 注销事件
     * @param name 事件名
     * @param callback 回调函数，未传入时注销事件名下注册的所有回调
     */
    off(name, callback) {
        const callbacks = this._eventMap.get(name);
        if (!callbacks) {
            return;
        }
        if (callback) {
            let idx = callbacks.indexOf(callback);
            while (idx > -1) {
                callbacks.splice(idx);
                idx = callbacks.indexOf(callback);
            }
            if (callbacks.length === 0) {
                this._eventMap.delete(name);
            }
        }
        else {
            this._eventMap.delete(name);
        }
    }
    /**
     * 注册事件
     * @param name 事件名
     * @param callback 回调函数
     */
    on(name, callback) {
        const callbacks = this._eventMap.get(name) || [];
        callbacks.push(callback);
        this._eventMap.set(name, callbacks);
    }
}

var Event = /*#__PURE__*/Object.freeze({
    __proto__: null,
    EventBus: EventBus,
    'default': EventBus
});

// 默认缓存期限为7天
const DEFAULT_CACHE_TIME = 168;
/**
 * 本地缓存类
 * @class Storage
 */
class BaseStorage {
    _storage;
    constructor(storage) {
        this._storage = storage;
    }
    /**
     * @description 设置缓存
     * @param {string} key 缓存键
     * @param {*} value 缓存值
     * @param expire 时效
     */
    set(key, value, expire = DEFAULT_CACHE_TIME) {
        const hourToMs = 3600000;
        const stringData = JSON.stringify({
            value,
            expire: expire !== null ? new Date().getTime() + expire * hourToMs : null,
        });
        this._storage.setItem(key, stringData);
    }
    /**
     * 读取缓存
     * @param {string} key 缓存键
     * @param {*=} def 默认值
     */
    get(key, def = null) {
        const item = this._storage.getItem(key);
        if (item) {
            try {
                const data = JSON.parse(item);
                // 只已经不存在了，说明失效了，返回默认值
                if (data !== null) {
                    const { value, expire } = data;
                    // 在有效期内直接返回
                    if (expire === null || expire === undefined || expire >= Date.now()) {
                        return value;
                    }
                    this.remove(key);
                }
            }
            catch (e) {
                return def;
            }
        }
        return def;
    }
    /**
     * 从缓存删除某项
     * @param {string} key
     */
    remove(key) {
        this._storage.removeItem(key);
    }
    /**
     * 清空所有缓存
     * @memberOf Cache
     */
    clear() {
        this._storage.clear();
    }
}
/** cookie的缓存 */
class CKStorage {
    length = 0;
    /**
     * 设置Cookie值
     * @param key
     * @param value 格式 {value:string,expire:number}
     */
    setItem(key, value) {
        const valueData = JSON.parse(value);
        // 先查找是否存在
        const cookieArr = document.cookie.split('; ');
        let exist = false;
        for (let i = 0, length = cookieArr.length; i < length; i++) {
            const kv = cookieArr[i].split('=');
            if (kv[0] === key) {
                exist = true;
            }
        }
        const expireTime = new Date(valueData.expire).toUTCString();
        document.cookie = `${key}=${valueData.value}; expires=${expireTime}; path=/;`;
        if (!exist) {
            // 不存在，增加长度
            this.length++;
        }
    }
    /**
     * 读取Cookie值
     * @param key
     * @returns value
     */
    getItem(key) {
        const cookieArr = document.cookie.split('; ');
        for (let i = 0, length = cookieArr.length; i < length; i++) {
            const kv = cookieArr[i].split('=');
            if (kv[0] === key) {
                return `{"value":"${kv[1]}"}`;
            }
        }
        return null;
    }
    /**
     * 清理所有的Cookie
     */
    clear() {
        const keys = document.cookie.match(/[^ =;]+(?==)/g);
        if (keys) {
            for (let i = keys.length; i--;) {
                document.cookie = `${keys[i]}=0; expire = ${new Date(0).toUTCString()} `;
            }
        }
        this.length = 0;
    }
    /**
     * 删除单个Cookie
     * @param key
     */
    removeItem(key) {
        const valueData = { value: 1, expire: -1 };
        this.setItem(key, JSON.stringify(valueData));
        this.length--;
    }
    /**
     * 没用到，就没实现
     * @param index
     * @returns
     */
    key(index) {
        console.log('该方法未实现：' + index);
        return '该方法未实现';
    }
}
const Storage = new BaseStorage(localStorage);
const SessionStorage = new BaseStorage(sessionStorage);
const CookieStorage = new BaseStorage(new CKStorage());

var Storage$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SessionStorage: SessionStorage,
    CookieStorage: CookieStorage,
    Storage: Storage
});

/**
 * 一个Promise封装的setTimeout
 * @param ms 毫秒单位的timeout，默认值为0
 * @returns 一个ms后resolve的Promise
 */
function PromisedSetTimeout(ms = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

var PromiseUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PromisedSetTimeout: PromisedSetTimeout
});

/**
 * 在指定数组中，从给定索引开始，查找第一个符合条件的元素的索引
 * @param array 要查询的数组
 * @param predicate 断言函数，接收三个参数：当前元素、当前元素索引、当前数组
 * @param fromIndex 从哪个索引开始查询，默认为0
 * @returns 查询到的元素的索引，如果没有查询到则返回-1
 */
function findIndexFromIndex(array, predicate, fromIndex = 0) {
    const length = array.length;
    for (let i = fromIndex; i < length; i++) {
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
/**
 * 在指定数组中，从给定索引开始，查找第一个符合条件的元素
 * @param array 要查询的数组
 * @param predicate 断言函数，接收三个参数：当前元素、当前元素索引、当前数组
 * @param fromIndex 从哪个索引开始查询，默认为0
 * @returns 查询到的元素，如果没有查询到则返回undefined
 */
function findFormIndex(array, predicate, fromIndex = 0) {
    const length = array.length;
    for (let i = fromIndex; i < length; i++) {
        if (predicate(array[i], i, array)) {
            return array[i];
        }
    }
    return void 0;
}

var ArrayUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    findIndexFromIndex: findIndexFromIndex,
    findFormIndex: findFormIndex
});

/** 根据设备浏览器信息生成唯一标识符 */
class DeviceIdentifier {
    static fontList = [
        'Arial',
        'Verdana',
        'Times New Roman',
        'Courier New',
        'Georgia',
        'Comic Sans MS',
        'Trebuchet MS',
        'Arial Black',
        'Impact',
    ];
    /** 生成字符串哈希 */
    static hashString(str) {
        return Array.from(str)
            .reduce((hash, char) => {
            hash = (hash << 5) - hash + char.charCodeAt(0);
            return hash & hash;
        }, 0)
            .toString(16);
    }
    /** 获取屏幕分辨率 */
    static getScreenSize() {
        return `${screen.width}x${screen.height}`;
    }
    /** 获取视口尺寸 */
    static getViewportSize() {
        return `${window.innerWidth}x${window.innerHeight}`;
    }
    /** 获取系统中可用的字体 */
    static getAvailableFonts() {
        const availableFonts = [];
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            const text = 'abcdefghijklmnopqrstuvwxyz0123456789';
            this.fontList.forEach((font) => {
                context.font = `16px ${font}`;
                const width = context.measureText(text).width;
                context.font = '16px monospace';
                if (context.measureText(text).width !== width) {
                    availableFonts.push(font);
                }
            });
        }
        return availableFonts.join(',');
    }
    /** 获取 WebGL 渲染器信息 */
    static getWebGLRenderer() {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl');
        if (gl) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            return debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : null;
        }
        return null;
    }
    /** 获取 Canvas 指纹 */
    static getCanvasFingerprint() {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            context.textBaseline = 'alphabetic';
            context.font = '14px Arial';
            context.fillStyle = '#f60';
            context.fillRect(125, 1, 62, 20);
            context.fillStyle = '#069';
            context.fillText('Hello, world!', 2, 15);
            context.fillStyle = 'rgba(102, 204, 0, 0.7)';
            context.fillText('Hello, world!', 4, 17);
        }
        return canvas.toDataURL();
    }
    /** 生成设备指纹 */
    static generateFingerprint() {
        const fingerprintData = [
            this.getScreenSize(),
            this.getViewportSize(),
            screen.colorDepth,
            navigator.userAgent,
            navigator.platform,
            navigator.language,
            Array.from(navigator.plugins)
                .map((plugin) => plugin.name)
                .join(','),
            navigator.doNotTrack,
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            new Date().getTimezoneOffset(),
            this.getAvailableFonts(),
            navigator.hardwareConcurrency,
            navigator.deviceMemory ?? 'unknown',
            this.getWebGLRenderer(),
            this.getCanvasFingerprint(),
            'ontouchstart' in window || navigator.maxTouchPoints > 0,
        ].join('|');
        return this.hashString(fingerprintData);
    }
    /** 获取设备标识信息 */
    getDeviceIdentifier() {
        return {
            uuid: getRandomGuid,
            fingerprint: DeviceIdentifier.generateFingerprint(),
        };
    }
}
const deviceIdentifier = new DeviceIdentifier();

var DeviceUtil = /*#__PURE__*/Object.freeze({
    __proto__: null,
    deviceIdentifier: deviceIdentifier
});

const iconColorsArr = ['#FF4384', '#7457FF', '#FF7527', '#05DB9B', '#FFCA00'];
const iconColorsLimit = 3;
const calcIconColor = (objectId) => {
    const substr = objectId.slice(-iconColorsLimit);
    const long = Array.from(substr).reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const index = long % iconColorsArr.length;
    return iconColorsArr[index];
};

var CalcColor = /*#__PURE__*/Object.freeze({
    __proto__: null,
    calcIconColor: calcIconColor
});

/**
 * 从数组生成树
 * @param array 数组
 * @param keys 树节点的key配置
 * @param extraKeys 生成数据时额外增加字段的配置
 */
function createTreeFromArray(array, keys, extraKeys) {
    const { key = 'key', parentKey = 'parentKey' } = keys || {};
    const map = array
        .map((item) => {
        const treeNode = {
            data: item,
            children: [],
        };
        if (extraKeys) {
            for (const [_treeKey, _generator] of extraKeys) {
                treeNode[_treeKey] = _generator(item);
            }
        }
        return treeNode;
    })
        .reduce((map, cur) => {
        const _key = cur.data[key];
        map.set(_key, cur);
        return map;
    }, new Map());
    for (const treeNode of map.values()) {
        const _parentKey = treeNode.data[parentKey];
        const _parent = map.get(_parentKey);
        if (_parent) {
            _parent.children.push(treeNode);
        }
    }
    for (const [_key, treeNode] of map) {
        const _parentKey = treeNode.data[parentKey];
        const _parent = map.get(_parentKey);
        if (_parent) {
            map.delete(_key);
        }
    }
    return [...map.values()];
}
/**
 * 在树中查找树节点
 * @param tree 树
 * @param keyValue 要查找的树节点的key值
 * @param keys 树节点的key配置
 */
function getTreeNode(tree, keyValue, keyField) {
    const _key = keyField ?? 'key';
    for (const treeNode of tree) {
        if (treeNode.data[_key]) {
            return treeNode;
        }
        const res = getTreeNode(treeNode.children ?? [], keyValue, keyField);
        if (res) {
            return res;
        }
    }
    return void 0;
}

var Tree = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createTreeFromArray: createTreeFromArray,
    getTreeNode: getTreeNode
});

/* eslint-disable @typescript-eslint/no-loss-of-precision */
/**
 * 提供了百度坐标（BD-09）、国测局坐标（火星坐标，GCJ-02）、和 WGS-84 坐标系之间的转换
 */
const X_PI = (3.14159265358979324 * 3000.0) / 180.0;
const PI = 3.1415926535897932384626;
const EARTH_EQUATORIAL_RADIUS = 6378245.0;
const EARTH_FLATTENING_PARAMETER = 0.00669342162296594323;
/**
 * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02) 的转换
 * 即 百度 转 谷歌、高德
 * @param bdLng
 * @param bdLat
 */
function bd09ToGcj02(_bdLng, _bdLat) {
    const bdLng = +_bdLng;
    const bdLat = +_bdLat;
    const x = bdLng - 0.0065;
    const y = bdLat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    const ggLng = z * Math.cos(theta);
    const ggLat = z * Math.sin(theta);
    return [ggLng, ggLat];
}
/**
 * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
 * 即 谷歌、高德 转 百度
 * @param lng
 * @param lat
 */
function gcj02ToBd09(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * X_PI);
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * X_PI);
    const bdLng = z * Math.cos(theta) + 0.0065;
    const bdLat = z * Math.sin(theta) + 0.006;
    return [bdLng, bdLat];
}
/**
 * WGS-84 转 GCJ-02
 * @param lng
 * @param lat
 */
function wgs84ToGcj02(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    if (out_of_china(lng, lat)) {
        return [lng, lat];
    }
    else {
        let dLat = transformLat(lng - 105.0, lat - 35.0);
        let dLng = transformLng(lng - 105.0, lat - 35.0);
        const radLat = (lat / 180.0) * PI;
        let magic = Math.sin(radLat);
        magic = 1 - EARTH_FLATTENING_PARAMETER * magic * magic;
        const sqrtMagic = Math.sqrt(magic);
        dLat =
            (dLat * 180.0) /
                (((EARTH_EQUATORIAL_RADIUS * (1 - EARTH_FLATTENING_PARAMETER)) / (magic * sqrtMagic)) * PI);
        dLng = (dLng * 180.0) / ((EARTH_EQUATORIAL_RADIUS / sqrtMagic) * Math.cos(radLat) * PI);
        const mgLat = lat + dLat;
        const mgLng = lng + dLng;
        return [mgLng, mgLat];
    }
}
/**
 * GCJ-02 转换为 WGS-84
 * @param lng
 * @param lat
 */
function gcj02ToWgs84(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    if (out_of_china(lng, lat)) {
        return [lng, lat];
    }
    else {
        let dLat = transformLat(lng - 105.0, lat - 35.0);
        let dLng = transformLng(lng - 105.0, lat - 35.0);
        const radLat = (lat / 180.0) * PI;
        let magic = Math.sin(radLat);
        magic = 1 - EARTH_FLATTENING_PARAMETER * magic * magic;
        const sqrtMagic = Math.sqrt(magic);
        dLat =
            (dLat * 180.0) /
                (((EARTH_EQUATORIAL_RADIUS * (1 - EARTH_FLATTENING_PARAMETER)) / (magic * sqrtMagic)) * PI);
        dLng = (dLng * 180.0) / ((EARTH_EQUATORIAL_RADIUS / sqrtMagic) * Math.cos(radLat) * PI);
        const mgLat = lat + dLat;
        const mgLng = lng + dLng;
        return [lng * 2 - mgLng, lat * 2 - mgLat];
    }
}
function transformLat(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
    ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
    return ret;
}
function transformLng(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
    ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
    return ret;
}
/**
 * 判断是否在国内，不在国内则不做偏移
 * @param lng
 * @param lat
 */
function out_of_china(_lng, _lat) {
    const lat = +_lat;
    const lng = +_lng;
    // 纬度 3.86~53.55, 经度 73.66~135.05
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
}

var CoordTransform = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bd09ToGcj02: bd09ToGcj02,
    gcj02ToBd09: gcj02ToBd09,
    wgs84ToGcj02: wgs84ToGcj02,
    gcj02ToWgs84: gcj02ToWgs84
});

// 按钮前端自定义代码类名匹配
const FrontClassNameRegex = /export\s+(?:default\s+)?class\s+((?:(@\{))?[a-zA-Z][a-zA-Z0-9_]+(?:\})?)( extends H3BaseButton)/;
// 按钮后端自定义代码类名匹配
const BackendClassNameRegex = /([^_\s]+_[^_\s]+)_SmartActionController/g;
/**
 * 获取执行自定义代码按钮替换后的前端代码
 * @param code
 * @param replaceText
 * @returns
 */
function getActionFrontCode(code, schemaCode, actionCode) {
    const replaceText = `export default class ${schemaCode}_${actionCode} extends H3BaseButton`;
    return code.replace(FrontClassNameRegex, replaceText);
}
/**
 * 获取执行自定义代码按钮替换后的后端代码
 * @param code
 * @param replaceText
 * @returns
 */
function getActionBehindCode(code, schemaCode, actionCode) {
    const replaceText = `${schemaCode}_${actionCode}_SmartActionController`;
    return code.replace(BackendClassNameRegex, replaceText);
}

var SmartAction = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getActionFrontCode: getActionFrontCode,
    getActionBehindCode: getActionBehindCode
});

const Util = {
    Navigator,
    Env,
    Storage: Storage$1,
    Url,
    Random,
    Clipboard,
    File,
    IS,
    Char,
    Event,
    Dom,
    Token,
    Number: NumberUtil,
    JSON: JSONUtil,
    RegExp: RegExpUtil,
    Object: ObjectUtil,
    Promise: PromiseUtil,
    Array: ArrayUtil,
    DeviceUtil,
    CalcColor,
    Tree,
    CoordTransform,
    SmartAction,
};

export { Util };
